import axios from "axios"
import {
  
  HelloReturnType,
  
} from "./types"

import {API_BASE} from "./config"

console.log("API_BASE", API_BASE)
axios.defaults.withCredentials = true
// const SERVER_BASE_URL = process.env.NODE_ENV === "production" ? "" : "http://localhost:4272"

export const hello = async (body: { n: number }): Promise<HelloReturnType> => {
  // return (await axios.post(`${API_BASE}/hello`, body)).data
  return (await axios.post(`${API_BASE}/hello`, body)).data
}

export const saveImage = async (dataUrl: string): Promise<void> => {
  await axios.post(`${API_BASE}/save-image`, { data: dataUrl })
}

export const removeBackgroundAI = async (blob: Blob, filename: string = "photo.png"): Promise<Blob> => {
  try {
    const form = new FormData()
    form.append("file", blob, filename)
    const response = await axios.post(`${API_BASE}/remove-background`, form, {
      responseType: "blob",
    })
    return response.data as Blob
  } catch (err: any) {
    const data = err?.response?.data
    if (data instanceof Blob) {
      const text = await data.text()
      let message = text
      try {
        const parsed = JSON.parse(text)
        message = parsed?.error || text
      } catch {
        // Keep raw text when response is not JSON.
      }
      throw new Error(message || "AI background removal failed.")
    }
    throw new Error(err?.message || "AI background removal failed.")
  }
}

export interface Feedback {
  id: number
  user: string
  comments: string
  ts: string
}

export const submitFeedback = async (user: string, comments: string): Promise<void> => {
  await axios.post(`${API_BASE}/feedback`, { user, comments })
}

export const getFeedbacks = async (): Promise<Feedback[]> => {
  return (await axios.get(`${API_BASE}/feedbacks`)).data
}

export const logEvent = async (payload: Record<string, unknown>): Promise<void> => {
  try {
    await axios.post(`${API_BASE}/log`, payload)
  } catch { /* best-effort, never block UI */ }
}

